import React from "react";
import { t } from "ttag";

export const Cash = (): React.ReactNode => {
    return (
        <div className="form__error">
            <p>
                <strong>
                    {t`Please enter payment information directly into the ERP.`}
                </strong>
            </p>
        </div>
    );
};
